import isEmpty from 'lodash/isEmpty';
import { ReviewAttributes } from '@fiverr-private/gig_page_types';

interface ValidateReviewsSnippetArgs {
    reviewAttributes: ReviewAttributes;
    isLimitedEdition: boolean;
}

export const validateReviewsSnippet = ({ reviewAttributes, isLimitedEdition }: ValidateReviewsSnippetArgs) =>
    !isLimitedEdition && !!(reviewAttributes && !isEmpty(reviewAttributes.reviewSnippets));
